import { getMetaSubtreeEntityIds } from '~/utils/viewer/metadata-graph';

export function xRayOthersAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.x_ray_others') || 'X-Ray Others',

    doAction: function (context) {
      const viewer = context.viewer;
      const scene = viewer.scene;
      const entity = context.entity;
      const metaId = String(entity.originalSystemId ?? entity.id);
      const subtreeIds = getMetaSubtreeEntityIds(viewer, metaId);

      if (!subtreeIds.length) return;

      scene.setObjectsVisible(scene.objectIds, true);
      scene.setObjectsXRayed(scene.objectIds, true);
      scene.setObjectsSelected(scene.selectedObjectIds, false);
      scene.setObjectsHighlighted(scene.highlightedObjectIds, false);

      for (const objectId of subtreeIds) {
        const subtreeEntity = scene.objects[objectId];
        if (subtreeEntity) {
          subtreeEntity.xrayed = false;
        }
      }
    },
  };
}
